import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// components
import { FormProvider } from '@growdash/design-system/molecules';
import { Auth } from '@growdash/identity/components';
// context
import { useAuthContext } from '@context/auth/use-auth-context';
import { useSettingsContext } from '@context/settings';
// integrations
// hooks
import { useRouter, useSearchParams } from '@hooks/routes';
// configs
import { PATH_AFTER_LOGIN } from '@integrations/config-global';
import { paths } from '@routes/paths';
// routes
// ----------------------------------------------------------------------

const JwtLoginView = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const { authenticated, login } = useAuthContext();
  const settings = useSettingsContext();

  const [errorMsg, setErrorMsg] = useState('');

  const returnTo = searchParams.get('returnTo');

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email must be a valid email address')
      .required('Email is required'),
    password: Yup.string().required('Password is required')
  });

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues: {
      email: '',
      password: ''
    }
  });

  const {
    handleSubmit,
    resetField,
    formState: { isSubmitting }
  } = methods;

  // TODO: uncomment excode when endpoints ready
  const onSubmit = handleSubmit(async data => {
    settings.onUpdate('themeLayout', 'vertical');
    try {
      await login?.(data.email, data.password);

      const baseUrl = returnTo || PATH_AFTER_LOGIN;
      const separator = baseUrl.includes('?') ? '&' : '?';
      const urlWithParam = `${baseUrl}${separator}`;

      router.push(urlWithParam);
    } catch (error) {
      resetField('password');
      if (error.response?.data?.message) {
        setErrorMsg(error.response.data.message);
      } else if (error.message) {
        setErrorMsg(error.message);
      } else {
        setErrorMsg('An unexpected error occurred');
      }
    }
  });

  useEffect(() => {
    if (authenticated) {
      router.push(PATH_AFTER_LOGIN);
    }
    setErrorMsg('');
  }, [authenticated, router]);

  const handleForgotPassword = () => {
    router.push(paths.auth.jwt.forgot_password);
  };

  const handleSignUp = () => {
    router.push(paths.auth.jwt.sign_up);
  };

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Auth
        isSubmitting={isSubmitting}
        errorMessage={errorMsg}
        handleForgotPassword={handleForgotPassword}
        handleSignUp={handleSignUp}
      />
    </FormProvider>
  );
};

export default JwtLoginView;
